import CategoryShoppers from './CategoryShoppers.Container';

export default CategoryShoppers;
